"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { ListCtaLocation } from "@/lib/analytics/events";
import { useTranslations } from "next-intl";
import { ListYourEventGuide } from "./ListYourEventGuide";

interface ListYourEventDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  location: ListCtaLocation;
}

export function ListYourEventDialog({
  open,
  onOpenChange,
  location,
}: ListYourEventDialogProps) {
  const t = useTranslations("listYourEvent");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t("title")}</DialogTitle>
          <DialogDescription>{t("description")}</DialogDescription>
        </DialogHeader>
        <ListYourEventGuide location={location} />
      </DialogContent>
    </Dialog>
  );
}
